import { enqueueSnackbar } from 'notistack'

import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'

const fallbackCopy = text => {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.readOnly = true
  textarea.style.position = 'fixed'
  textarea.style.top = '-1000px'
  textarea.style.left = '-1000px'
  document.body.appendChild(textarea)
  textarea.focus()
  textarea.select()
  textarea.setSelectionRange(0, textarea.value.length)

  let copied = false
  try {
    copied = document.execCommand('copy')
  }
  catch {
    copied = false
  }

  document.body.removeChild(textarea)
  return copied
}

const copyText = async text => {
  if (navigator?.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    }
    catch {}
  }

  return fallbackCopy(text)
}

const getCopyText = ({ source, children }) => {
  if (typeof source === "string") return source
  if (source instanceof URL) return source.href
  if (source != null) return String(source)
  if (typeof children === "string") return children
  return ""
}

const ClickToCopy = ({ children, side = "left", source, successMessage = "Copied to clipboard", failureMessage = "Unable to copy" }) => {
  const handleCopy = async event => {
    event?.stopPropagation?.()

    const text = getCopyText({ source, children })
    if (!text.length) return

    try {
      const copied = await copyText(text)
      enqueueSnackbar({ message: copied ? successMessage : failureMessage, variant: copied ? 'success' : 'error' })
    }
    catch {
      enqueueSnackbar({ message: failureMessage, variant: 'error' })
    }
  }

  const content = side === "left"
    ? <><ContentCopyOutlinedIcon className='mr-5' /> {children}</>
    : <>{children} <ContentCopyOutlinedIcon className='ml-5' /></>

  return (
      <span onClick={handleCopy} style={{ cursor: 'pointer' }} className='link'>
        {content}
      </span>
  )
}

export default ClickToCopy
